export default __webpack_public_path__ + "assets/images/CVV-mobile-back_aed3dc3b86e2f0018c02ee0ef5476a80.png";